// Patients page content, taken from the existing KUR Patients page, its FAQ,
// and the participation benefits described on the Physicians page.

import heroImage from "../ASSETS/IMAGES/patientsHero.jpg";

export const patientsHero = {
  lead: "Clinical research lays the foundation that's necessary to make advancements in healthcare. The advancements made through clinical research offer all patients new treatment options and life-changing decisions.",
  actions: [
    { label: "Talk to a patient advocate", href: "#contact" },
    { label: "Read the FAQ", href: "#faq" },
  ],
  note: "Volunteering for a clinical trial means contributing to the development of treatments and impacting future generations.",
  image: heroImage,
  imageAlt: "Patient speaking with a clinician",
};

export const steps = [
  {
    title: "Reach out",
    text: "Share your details and a patient advocate will reach out to you about studies and the process.",
  },
  {
    title: "Visit a KUR facility",
    text: "Volunteers attend one of our medical facilities where our team explains the study.",
  },
  {
    title: "Understand risks and consent",
    text: "The team walks you through the study's risks, benefits, and consent form before anything begins.",
  },
  {
    title: "Take part and return to routine",
    text: "After completing the trial, volunteers are compensated for their time and travel and return to their routine.",
  },
];

export const participation = [
  { title: "No cost to take part", text: "Patients that participate in clinical studies do so at no cost to them." },
  { title: "Compensation", text: "Volunteers are typically compensated for their time and travel, depending on the study." },
  { title: "A higher level of care", text: "Participants receive a higher level of care throughout the study." },
  { title: "Learn about your condition", text: "Participants learn significantly more about their illnesses." },
];

export const faqs = [
  {
    question: "What is clinical research?",
    answer:
      "Clinical trials provide answers to scientific questions that help find the best ways to prevent, diagnose, and treat diseases and medical conditions. Clinical trials include the evaluation of devices, medications, and diagnostic products. Studies are conducted by a trained medical research team and conform to Good Clinical Practice (GCP) and FDA guidelines.",
  },
  {
    question: "What are clinical trials?",
    answer:
      "Clinical trials are studies led by experienced research teams to find answers for advanced medicine. These trials help diagnose diseases, find new drug indications, and develop or improve medical devices, all conducted with patient safety as the focus.",
  },
  {
    question: "Who can participate?",
    answer:
      "Anyone can participate, from toddlers to elderly patients, if they qualify for the study design. Both healthy and sick patients may volunteer based on the study's criteria.",
  },
  {
    question: "What is the process?",
    answer:
      "Volunteers attend one of our medical facilities where our team explains the study, risks, benefits, and consent form. After completing the trial, volunteers are compensated and return to their routine.",
  },
  {
    question: "What is the compensation?",
    answer:
      "Clinical trials compensate volunteers for their time and travel, depending on the study they qualify for.",
  },
];
